import {
  sendCustomAction,
  setGlobalContextProperty,
} from "datadog-loader/loader";

import { getFeClient } from "frontend-client";

export const fetchClient = ({
  apiHost,
  version,
  target,
}: {
  apiHost: string;
  version: string;
  target?: string;
}) => {
  return getFeClient(
    apiHost,
    target,
    version,
    sendCustomAction,
    setGlobalContextProperty
  );
};
